const getPlatform = (): string | null => {
  const platform = localStorage.getItem("platform");
  if (platform) return platform;
  return null;
};

export default getPlatform;
